// https://stackoverflow.com/questions/1787322
export function htmlspecialchars(text) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return (typeof text === 'string')
    ? text.replace(/[&<>"']/g, function(m) { return map[m]; })
    : '';
}
